import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function ModalInactiveGroup({
  modalInactiveGroupControl = {
    open: false,
    groupId: '',
    groupName: '',
  },
  setModalInactiveGroupControl,
  tryDeleteGroup,
}) {
  if (!modalInactiveGroupControl.open) { return null }
  return (
    <SweetAlert
      warning
      showCancel
      title={'Atenção'}
      confirmBtnText="Sim"
      cancelBtnText="Não"
      confirmBtnBsStyle="success"
      cancelBtnBsStyle="danger"
      onCancel={() => setModalInactiveGroupControl({ ...modalInactiveGroupControl, open: false })}
      onConfirm={() => tryDeleteGroup()}
    >
      Tem certeza que deseja deletar o grupo {modalInactiveGroupControl.groupName}?
    </SweetAlert>
  )
}
